var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echart-container"},[(_vm.empty)?_c('van-empty',{attrs:{"description":"暂无数据"}}):_c('div',{ref:"echart",staticClass:"echart-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }